let selectMessage = (state, { payload }) => {
    let isSelected = state.selectedMessages.find(({ id }) => payload.id === id);
    if (!isSelected) state.selectedMessages.push(payload);
    else state.selectedMessages = state.selectedMessages.filter((message) => message.id !== payload.id);
};

export default selectMessage;
